export const CONTEXT_MAX_LENGTH = 500;
export const TEXT_MAX_LENGTH = 10000;
